import { NavGroup } from "./nav-group";
import { navGroupLabels, settingsNav } from "@/constants/nav.constants";
import { useVisibleNav } from "@/features/navigation/hooks/use-visible-nav";

/** Settings-style entries, shown at the bottom of the sidebar above the account switcher. */
export function NavSettings() {
  const visibleNav = useVisibleNav(settingsNav);

  // No inset override here. The group's own px-5 -> px-3 is what aligns these
  // items with the rest of the nav and what centers them in the collapsed rail.
  return <NavGroup label={navGroupLabels.settings} entries={visibleNav} />;
}
